import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

//for proposal
const initialState = {
  allProposal: {},
  loading: false,
  error: null,
}

const fetch_all_proposalSuccess = (state, action) => {

  return updateObject(state, {

    allProposal: action.allProposal,
    loading: false,
    error: null,
  });
};

const fetch_all_proposalStart = (state, action) => {
  return updateObject(state, {
    loading: true,
    error: null,
  });
};

const fetch_all_proposalFail = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: action.error,
  });
};

const reducer = (state = initialState, action) => {


  switch (action.type) {
    // leadtchh
    case actionTypes.FETCH_ALL_PROPOSAL_AGENT_DETAILS:
      return fetch_all_proposalSuccess(state, action);
    case actionTypes.FETCH_ALL_PROPOSAL_AGENT_DETAILS_START:
      return fetch_all_proposalStart(state, action);
    case actionTypes.FETCH_ALL_PROPOSAL_AGENT_DETAILS_FAIL:
      return fetch_all_proposalFail(state, action);


    default:
      return state;


  }
};

export default reducer;